export * from './alert.constants';
export * from './user.constants';
export * from './event.constant';
export * from './master.constant';

export const commaFormatter = (num, formatDigit) => {
    const number = num ? num : 0;
    let formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: formatDigit,
    });
  
    return formatter.format(parseFloat(number).toFixed(formatDigit));
  };
